"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const base_1 = require("./base");
/**
 * @author Eric MORAND <eric.morand@gmail.com>
 */
class TwingProfilerDumperHtml extends base_1.TwingProfilerDumperBase {
    dump(profile) {
        return '<pre>' + super.dump(profile) + '</pre>';
    }
    formatTemplate(profile, prefix) {
        return `${prefix}└ <span style="background-color: ${TwingProfilerDumperHtml.colors['template']}">${profile.getTemplate()}</span>`;
    }
    formatNonTemplate(profile, prefix) {
        let color = TwingProfilerDumperHtml.colors[profile.getType()];
        return `${prefix}└ ${profile.getTemplate()}::${profile.getType()}(<span style="background-color: ${color}">${profile.getName()}</span>)`;
    }
    formatTime(profile, percent) {
        let color = TwingProfilerDumperHtml.colors['big'];
        return `<span style="color: ${color}">${(profile.getDuration() * 1000).toFixed(2)}ms/${percent}%</span>`;
    }
}
exports.TwingProfilerDumperHtml = TwingProfilerDumperHtml;
TwingProfilerDumperHtml.colors = {
    block: '#dfd',
    macro: '#ddf',
    template: '#ffd',
    big: '#d44'
};
